function ffInitHeaderMenu(menuContainer) {
  const blockId = menuContainer.dataset.ffBlockId;
  const breakpoint = parseInt(menuContainer.dataset.ffBreakpoint);
  const isBackgroundMode = menuContainer.dataset.ffBackgroundMode === 'true';


  const container = document.getElementById('shopify-block-' + blockId);
  if (!container) return;

  const isMobile = window.innerWidth < breakpoint;
  const collapsibleTabs = menuContainer.querySelector('ff-collapsible-tabs');
  const menuItemWrappers = menuContainer.querySelectorAll('.ff-menu__item-wrapper');
  const submenus = container.querySelectorAll('.ff-submenu-block');

  const submenuHandles = new Set();
  submenus.forEach(submenu => {
    const handle = submenu.dataset.parentLinkHandle;
    if (handle) submenuHandles.add(handle);
  });

  if (!isMobile) {
    // Phase 1: Prepare elements (batch writes)
    const submenuElements = Array.from(submenus).map(subMenu => {
      const element = isBackgroundMode
        ? subMenu.querySelector('.ff-submenu-content') || subMenu
        : subMenu;
      element.classList.replace('ff-d-none', 'ff-d-flex');
      element.classList.add('ff-opacity-0', 'ff-active');
      return { element, linkHandle: subMenu.dataset.parentLinkHandle };
    });

    // Phase 2: Batch read all measurements (single reflow)
    const submenuData = submenuElements.map(({ element, linkHandle }) => {
      const height = element.offsetHeight;
      const cs = window.getComputedStyle(element);
      const paddingTop = cs.getPropertyValue('--ff-padding-top') || cs.paddingTop;
      const paddingBottom = cs.getPropertyValue('--ff-padding-bottom') || cs.paddingBottom;
      return { element, linkHandle, height, paddingTop, paddingBottom };
    });

    // Phase 3: Batch write initial collapsed state (single rAF)
    requestAnimationFrame(() => {
      submenuData.forEach(({ element }) => {
        element.style.height = '0px';
        element.style.setProperty('--ff-padding-top', '0px');
        element.style.setProperty('--ff-padding-bottom', '0px');
        element.classList.remove('ff-active');
        element.style.transition = 'height 0.5s ease, opacity 0.5s ease, padding 0.5s ease';
      });

    });

    let closeTimeout = null;
    const CLOSE_DELAY = 150;

    const cancelClose = () => {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    };

    const openSubmenu = (linkHandle) => {
      cancelClose();
      submenuData.forEach(({ element, linkHandle: handle }) => {
        if (handle !== linkHandle) {
          element.classList.remove('ff-active');
          element.style.height = '0px';
          element.style.setProperty('--ff-padding-top', '0px');
          element.style.setProperty('--ff-padding-bottom', '0px');
          element.classList.add('ff-opacity-0');
        }
      });
      const targetSubmenu = submenuData.find(data => data.linkHandle === linkHandle);
      if (targetSubmenu) {
        const submenuTop = targetSubmenu.element.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;
        const maxHeight = viewportHeight - submenuTop - (viewportHeight * 0.1);
        const finalHeight = Math.min(targetSubmenu.height, maxHeight);
        const needsScroll = targetSubmenu.height > maxHeight;

        targetSubmenu.element.classList.remove('ff-opacity-0');
        targetSubmenu.element.classList.add('ff-active');
        targetSubmenu.element.style.height = finalHeight + 'px';
        targetSubmenu.element.style.overflowY = needsScroll ? 'auto' : 'hidden';
        targetSubmenu.element.style.setProperty('--ff-padding-top', targetSubmenu.paddingTop);
        targetSubmenu.element.style.setProperty('--ff-padding-bottom', targetSubmenu.paddingBottom);
      }
    };

    const closeSubmenuImmediate = () => {
      submenuData.forEach(({ element }) => {
        element.classList.remove('ff-active');
        element.style.height = '0px';
        element.style.setProperty('--ff-padding-top', '0px');
        element.style.setProperty('--ff-padding-bottom', '0px');
        element.classList.add('ff-opacity-0');
      });
    };

    const closeSubmenu = () => {
      cancelClose();
      closeTimeout = setTimeout(closeSubmenuImmediate, CLOSE_DELAY);
    };

    menuItemWrappers.forEach(wrapper => {
      const linkHandle = wrapper.dataset.linkHandle;
      wrapper.addEventListener('mouseenter', () => {
        closeSubmenu();
        openSubmenu(linkHandle);
      });
    });

    menuContainer.addEventListener('mouseleave', (e) => {
      const rect = menuContainer.getBoundingClientRect();
      if (e.clientY < rect.bottom) closeSubmenu();
    });

    submenus.forEach(submenu => {
      submenu.addEventListener('mouseenter', cancelClose);
      submenu.addEventListener('mouseleave', (e) => {
        const rect = submenu.getBoundingClientRect();
        if (e.clientY >= rect.bottom) closeSubmenu();
      });
    });

    window.addEventListener('scroll', closeSubmenuImmediate, { passive: true });
  }

  if (isMobile) {
    const submenuContainer = container.querySelector('.ff-submenu__container');
    if (submenuContainer) {
      submenuContainer.style.display = 'none';
    }

    menuItemWrappers.forEach(wrapper => {
      const linkHandle = wrapper.dataset.linkHandle;
      const hasSubmenu = submenuHandles.has(linkHandle);
      const menuItem = wrapper.querySelector('.ff-menu__item');
      const buttonMedia = menuItem?.querySelector('.ff-button-media');
      const collapsibleContent = wrapper.querySelector('.ff-menu__collapsible-content');
      const contentInner = wrapper.querySelector('.ff-menu__collapsible-content-inner');

      if (!hasSubmenu) {
        if (buttonMedia) buttonMedia.style.visibility = 'hidden';
        if (collapsibleContent) collapsibleContent.style.display = 'none';
        if (menuItem) menuItem.classList.remove('ff-collapsible-tab-trigger');
        return;
      }

      const submenuBlock = container.querySelector('[data-parent-link-handle="' + linkHandle + '"]');

      if (submenuBlock && contentInner) {
        const mobileContent = submenuBlock.querySelector('.ff-submenu__mobile-content');
        if (mobileContent) {
          const clone = mobileContent.cloneNode(true);
          clone.classList.remove('ff-d-none');
          contentInner.innerHTML = '';
          contentInner.appendChild(clone);
        }
      }

      const linkButton = menuItem?.querySelector('a');
      if (linkButton) {
        linkButton.addEventListener('click', (e) => {
          e.preventDefault();
        });
      }
    });

    if (collapsibleTabs) {
      customElements.whenDefined('ff-collapsible-tabs').then(() => {
        if (collapsibleTabs.ffInit) {
          collapsibleTabs.ffInit();
        }

        collapsibleTabs.addEventListener('click', () => {
          requestAnimationFrame(() => {
            menuItemWrappers.forEach(wrapper => {
              const trigger = wrapper.querySelector('.ff-collapsible-tab-trigger');
              const button = wrapper.querySelector('.ff-snippet-button');
              if (!trigger || !button) return;

              if (trigger.classList.contains('ff-collapsible-tab-active')) {
                button.classList.add('ff-button-active');
              } else {
                button.classList.remove('ff-button-active');
              }
            });
          });
        });
      });
    }
  }
}

// Init: wait for DOM + rAF to ensure header has moved the menu block
function ffInitAllHeaderMenus() {
  requestAnimationFrame(() => {
    document.querySelectorAll('[data-ff-header-menu]').forEach(ffInitHeaderMenu);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ffInitAllHeaderMenus);
} else {
  ffInitAllHeaderMenus();
}
